// src/components/Popup.tsx

import React from 'react';
import { IoClose } from 'react-icons/io5';

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  contentClassName?: string; // optional custom width/styles for content
  ctaLabel?: string;
  ctaHref?: string;
}

const Popup: React.FC<PopupProps> = ({ isOpen, onClose, children, contentClassName, ctaLabel, ctaHref }) => {
  if (!isOpen) {
    return null;
  }

  return (
    // Contenedor principal del overlay (fondo oscuro semitransparente)
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4 transition-opacity duration-300">
      {/* Contenedor del contenido del modal (Fondo blanco, borde neutro, texto oscuro) */}
      <div className={`relative bg-white border border-neutral-200 text-neutral-900 rounded-lg shadow-xl p-6 md:p-8 w-full transform transition-all duration-300 scale-95 animate-scale-in popup-content ${contentClassName || 'max-w-3xl md:max-w-4xl'}`}>
        {/* Botón para cerrar: más visible en móvil (fondo blanco, sombra, mayor tamaño) */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-50 bg-white rounded-full p-2 shadow-md text-neutral-700 hover:text-neutral-900 focus:outline-none focus:ring-2 focus:ring-primary"
          aria-label="Cerrar"
        >
          <IoClose size={20} />
        </button>
        <div className="text-neutral-700 text-left">
          {children}
        </div>
        {/* Footer: optional CTA */}
        {(ctaLabel && ctaHref) ? (
          <div className="mt-6 flex justify-end">
            <a href={ctaHref} className="inline-flex items-center px-4 py-2 bg-primary text-white rounded-md shadow-sm hover:opacity-95 transition-opacity">
              {ctaLabel}
            </a>
          </div>
        ) : null}
      </div>
      <style jsx global>{`
        @keyframes scale-in {
          from {
            transform: scale(0.95);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
        .animate-scale-in {
          animation: scale-in 0.2s ease-out forwards;
        }
        .popup-content h2 { text-align: center; }
        /* Bio content paragraphs */
        .popup-content p {
          margin-bottom: 0.85rem;
          line-height: 1.7;
        }
        .popup-content p:last-child { margin-bottom: 0; }
        .popup-content strong { color: #141414; font-weight: 700; }
        /* mobile: larger close button hit area and ensure it's visible over images */
        @media (max-width: 767px) {
          .popup-content { padding-top: 3rem; }
          .popup-content button[aria-label="Cerrar"] { width: 44px; height: 44px; display: inline-flex; align-items: center; justify-content: center; }
        }
      `}</style>
    </div>
  );
};

export default Popup;
